import * as React from 'react';
import './App.css';
import Rail from './components/Rail';
import { ScreenProvider, ScreenContextProps } from './_context';
import Menu from './components/Menu/Component';
import Logo from './components/Logo/Component';
import Lightbox from './components/Lightbox';
import { ApiProvider } from './_context/Api';

interface State {
  showLightbox: boolean;
  showCaption: boolean;
  isMouseOver: boolean;
}

class WrappedApp extends React.Component<{} & ScreenContextProps, State> {
  constructor(props: {} & ScreenContextProps) {
    super(props);

    this._handleclick = this._handleclick.bind(this);
    this._handleKeydown = this._handleKeydown.bind(this);

    this.state = {
      showLightbox: false,
      showCaption: false,
      isMouseOver: false
    };
  }

  componentDidMount() {
    window.addEventListener('keydown', this._handleKeydown);
    window.addEventListener('click', this._handleclick);
  }

  componentWillUnmount() {
    window.removeEventListener('keydown', this._handleKeydown);
    window.removeEventListener('click', this._handleclick);
  }

  public render() {

    const headerHeigth = 70;

    const screenW = this.props.screenWidth;
    const screenH = this.props.screenHeight;

    let railHeight = this.props.screenHeight;

    const ratio = screenW / screenH;

    const cls = ['app'];

    let portraitBig = false;
    let collapse = false;

    if (ratio >= 0.83) {
      // align bottom, logo and menu on top
      railHeight = screenH;

      cls.push('app--landscape');
    } else if (screenH <= (screenW * 1.2 + 2 * headerHeigth)) {
      // align bottom, logo and menu on top
      railHeight = screenW * 1.2;

      cls.push('app--portrait');
      cls.push('app--portrait-small');
    } else {
      // align center, logo on top and menu on bottom
      railHeight = screenH - 140;

      cls.push('app--portrait');
      cls.push('app--portrait-big');
      portraitBig = true;
    }

    if (this.state.showLightbox) {
      cls.push('app--show-lightbox');
    }

    var T = screenW / 2 - (3 / 4 * railHeight / 2);
    collapse = T < (239 + 2 * 27) && !portraitBig;

    return (
      <ApiProvider>
        <div className={cls.join(' ')} >
          <div className="app__logo">
            <Logo logoCollapsed={collapse} />
          </div>
          <div className="app__rail">
            <ApiProvider.Consumer>
              {(apicontext) => (
                apicontext.maps.length !== 0 ? <Rail
                  maps={apicontext.maps}
                  getProject={apicontext.getProject}
                  height={railHeight}
                  width={screenW}
                  showCaption={this.state.showCaption}
                  isCaptionHovered={this.state.isMouseOver}
                  closeCaption={() => this.setState(() => ({showCaption : false}))}
                /> : null
              )}
            </ApiProvider.Consumer>
          </div>
          <div className="app__menu">
            <Menu
              showCaption={this.state.showCaption}
              showLightbox={this.state.showLightbox}
              changeCaption={(c: boolean) => { this.setState(prev => ({ showCaption: c })); }}
              changeLightbox={(l: boolean) => { this.setState(prev => ({ showLightbox: l })); }}
              isMouseOver={(h: boolean) => { this.setState(prev => ({ isMouseOver: h })); }}
              menuCollapsed={collapse}
            />
          </div>
          <div className="app__lightbox">
            <ApiProvider.Consumer>
              {(apicontext) => (
                <Lightbox
                  infos={apicontext.infos}
                  closeLightbox={() => { this.setState(prev => ({ showLightbox: false })); }}
                />)}
            </ApiProvider.Consumer>
          </div>
        </div>
      </ApiProvider>
    );
  }

  private _handleKeydown(e: KeyboardEvent) {
    switch (e.keyCode) {
      // case 37: // left
      // case 39: // right
      //   if (this.state.showCaption === false) { return; }
      //   this.setState(prev => ({ showCaption: false }));
      //   break;
      case 32:
        this.setState(prev => ({ showCaption: !prev.showCaption }));
        break;
      default:
        break;
    }
  }

  private _handleclick(e: MouseEvent) {
    if (!this.state.showCaption) {
      return;
    }

    this.setState(prev => ({ showCaption: false }));
  }

}
export const App = ScreenProvider.Inject(WrappedApp);
export default App;



// WEBPACK FOOTER //
// ./src/App.tsx